var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, } from "@/components/ui/Dialog";
import { ResponseModel } from "@/models/ResponseModel";
import { downloadFile } from "@/util/file";
import toast from "react-hot-toast";
export function DialogAtpveDetails(_a) {
    var _this = this;
    var service = _a.service, showAtpve = _a.showAtpve, setShowAtpve = _a.setShowAtpve, serviceReturn = _a.serviceReturn;
    var copyToClipboard = function () {
        try {
            navigator.clipboard.writeText((serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.numeroATPVe) || "");
            toast.success("Copiado com sucesso!");
        }
        catch (e) {
            toast.error("Ocorreu um erro ao copiar o código de barras. Tente novamente.");
        }
    };
    var showBase64Pdf = function () {
        var blob = new Blob([
            Uint8Array.from(atob((serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.pdfAtpvBase64) || ""), function (c) {
                return c.charCodeAt(0);
            }),
        ], { type: "application/pdf" });
        var url = URL.createObjectURL(blob);
        window.open(url, "atpve-detran");
    };
    var download = function () { return __awaiter(_this, void 0, void 0, function () {
        var filename, ret;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filename = "atpve" + new Date().getTime() + ".pdf";
                    return [4 /*yield*/, service.download({
                            base64: (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.pdfAtpvBase64) || "",
                            decoder: "standard",
                            filename: filename,
                            bucketPath: "",
                            contentType: "application/pdf",
                        })];
                case 1:
                    ret = _a.sent();
                    if (ResponseModel.isOk(ret)) {
                        downloadFile(ret.data.url, filename);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Dialog, __assign({ open: showAtpve, onOpenChange: function (open) { return setShowAtpve(open); } }, { children: _jsxs(DialogContent, __assign({ className: "bg-light-blue-100 sm:max-w-[688px]" }, { children: [_jsx(DialogHeader, __assign({ className: "mb-6 sm:mb-0" }, { children: _jsx(DialogTitle, __assign({ className: "text-[#404040]" }, { children: "ATPV-e" })) })), _jsxs("div", __assign({ className: "flex flex-col gap-2" }, { children: [_jsx("div", __assign({ className: "w-full max-w-[856px] flex flex-col justify-between px-6 py-1 rounded-lg" }, { children: _jsxs("div", __assign({ className: "flex justify-center sm:justify-between gap-4" }, { children: [_jsx("div", __assign({ className: "hidden sm:flex flex-col" }, { children: "N\u00FAmero:" })), _jsx("div", __assign({ className: "flex-col" }, { children: _jsx("div", { children: serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.numeroATPVe }) }))] })) })), _jsx("div", __assign({ className: "hidden sm:flex w-full max-w-[856px]  flex-col justify-between px-6 py-1 rounded-lg" }, { children: _jsxs("div", __assign({ className: "flex justify-center sm:justify-between gap-4" }, { children: [_jsx("div", __assign({ className: "hidden sm:flex flex-col" }, { children: "Visualizar ATPV-e:" })), _jsx("div", __assign({ className: "flex-col" }, { children: _jsx(Button, __assign({ onClick: showBase64Pdf, variant: "outline", className: "self-end w-full max-w-[352px] min-w-[240px] bg-transparent text-etipi-blue border-2  border-etipi-blue" }, { children: "Abrir em uma nova guia" })) }))] })) })), _jsx("div", __assign({ className: "w-full max-w-[856px] flex flex-col justify-between px-6 py-1 rounded-lg" }, { children: _jsxs("div", __assign({ className: "flex justify-center sm:justify-between gap-4" }, { children: [_jsx("div", __assign({ className: "hidden sm:flex flex-col" }, { children: "Baixar ATPV-e:" })), _jsx("div", __assign({ className: "flex-col" }, { children: _jsxs(Button, __assign({ onClick: download, variant: "outline", className: "self-end w-full max-w-[352px] min-w-[240px] bg-transparent text-white border-2  border-etipi-blue bg-etipi-blue" }, { children: ["Baixar ", _jsx("span", __assign({ className: "sm:hidden" }, { children: "ATPV-e" }))] })) }))] })) }))] })), _jsx(DialogFooter, __assign({ className: "sm:justify-start" }, { children: _jsx(DialogClose, __assign({ asChild: true }, { children: _jsx(Button, __assign({ type: "button", variant: "link", className: "justify-start text-etipi-blue text-base", onClick: function () { return setShowAtpve(false); } }, { children: "Fechar" })) })) }))] })) })));
}
